import { NetworkType } from '../types'

export const PDP_NETWORK_TYPE: NetworkType = 'PDP'
